import { UrlConfig } from '@shared/config/url.config';

export class AdminConfig {
  private static baseUrl = UrlConfig.urlAdmin;

  private static actions: string = AdminConfig.baseUrl + 'actions';

  private static parameters: string = AdminConfig.baseUrl + 'parameters';

  private static portalStatuses: string = AdminConfig.baseUrl + 'statuts';

  public static get getActionsListUrl(): string {
    return AdminConfig.actions;
  }

  public static get getParametersUrl(): string {
    return AdminConfig.parameters;
  }

  public static get getPortalStatusesUrl(): string {
    return AdminConfig.portalStatuses;
  }
}
